import './customDataTableWizard.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React from 'react'
import { TableConfig } from 'types/TableHeader'

import { TableContainer, TableWrapper } from './customDataTableWizard.style'

interface Props {
    tableConfig: TableConfig
    data: any[]
    selectedRow: any
    handleRowClick: (data: any) => void
}

export const CustomDataTableWizard: React.FC<Props> = ({ tableConfig, data, selectedRow, handleRowClick }) => {
    const rowClassName = (rowData: any) => ({
        'clickable-row': true,
        'selected-row': selectedRow && selectedRow[tableConfig.idName] === rowData[tableConfig.idName],
    })

    const nameTemplate = (rowData: any) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {rowData.color && (
                    <div
                        style={{
                            width: '21px',
                            height: '21px',
                            borderRadius: '50%',
                            backgroundColor: rowData.color,
                            marginRight: '8px',
                        }}
                    ></div>
                )}
                <span>{rowData.name}</span>
            </div>
        )
    }

    return (
        <TableContainer>
            <TableWrapper>
                {data.length > 0 ? (
                    <DataTable
                        value={data}
                        stripedRows
                        style={{ width: '100%' }}
                        rowClassName={rowClassName}
                        onRowClick={(e) => handleRowClick(e.data)}
                    >
                        {tableConfig.headers.map((header, index) => (
                            <Column
                                key={index}
                                field={header.field}
                                header={header.title}
                                body={header.field === 'name' ? nameTemplate : undefined}
                                bodyStyle={{ textAlign: header.align }}
                                headerStyle={{ textAlign: header.align }}
                                headerClassName="dataTableHeader"
                                sortable={header.sortable}
                            />
                        ))}
                    </DataTable>
                ) : (
                    <p>No data available.</p>
                )}
            </TableWrapper>
        </TableContainer>
    )
}
